/**
 * Created by orion on 05.03.17.
 */

import "core-js/stable/symbol";
import "core-js/stable/array/includes";
import "core-js/stable/array/iterator";
import "core-js/stable/array/some";
import "core-js/stable/array/find";
import "core-js/stable/object/entries";
import "core-js/stable/object/assign";
import "core-js/stable/object/keys";
import "core-js/stable/object/values";
import "core-js/stable/object/define-property";
import "core-js/stable/promise";
import "core-js/stable/string";
import "regenerator-runtime/runtime";
import "intersection-observer";

(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'bootstrap/js/alert.js';
import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/css/v4-shims.css';
import './hacks/to_global';
import mmApp from './angular/app/app';

// import axios from 'axios';
// axios.defaults.xsrfHeaderName = "X-CSRFToken"
// axios.defaults.xsrfCookieName = 'csrftoken'
// axios.defaults.headers.common['Cache-Control'] = 'no-cache';

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: GOOGLE_API_KEY,
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        v: '3.36',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
});
//legacy styles:
import '../../css/reset.css';
import '../../css/styles.css';
import './styles/sticky-footer.scss';

//styles
import './angular/app/styles/pages/blog_detail.scss';
import './angular/app/styles/pages/blog_settings.scss';
import './angular/app/styles/pages/blog_entry_detail.scss';
import './angular/app/styles/pages/conversations_list.scss';
import './angular/app/styles/la.scss';

// VUE

import cutNameFilter from './angular/app/shared/filters/name_cutter.filter';
import resolveUrl from './angular/app/shared/filters/resolveUrl';
import {abu as add_back_url} from './angular/app/shared/utils/back_url_generator';
import {backHrefQuery} from './angular/app/shared/utils/back_url_generator';
import infiniteScroll from 'vue-infinite-scroll';
import Vuex from "vuex";
import Vue from 'vue';
import RavenVuePlugin from "./raven/RavenVuePlugin";
import VueRouter from './vue/VueRouterSilenceDuplicationError';
import VueMeta from 'vue-meta';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});
Vue.use(VueObserveVisibility);

import VueHotkey from 'v-hotkey';

Vue.use(VueHotkey);

import Vue2TouchEvents from 'vue2-touch-events';
// Vue.config.devtools = true
// Vue.config.performance = true
import * as uiv from 'uiv';

// import MediaItemInline from './vue/common_components/MediaItemInline.vue';
import Switch from './vue/common_components/Switch.vue';
import SwitchWithLabel from './vue/common_components/SwitchWithLabel.vue';
import SimpleHeader from './vue/common_components/SimpleHeader.vue';
import FolderButton from './vue/common_components/FolderButton/FolderButton.vue';
import StuffPreview from './vue/common_components/StuffPreview.vue';
import VueSearchInput from './vue/common_components/SearchInput.vue';
import AudioToggle from './vue/common_components/AudioToggle.vue';
import FolderItem from './vue/common_components/FolderItem.vue';
import SimpleLink from './vue/common_components/SimpleLink.vue';
import SimpleLinkWithAvatar from './vue/common_components/SimpleLinkWithAvatar.vue';
import MediaPreview from './vue/common_components/MediaPreview.vue';
import LocationWithMarker from './vue/common_components/LocationWithMarker.vue';
import MediaPreviewAddRequest from './vue/common_components/MediaPreviewAddRequest.vue';
import InvitationTypeSelectPopup from './vue/common_components/invitations/InvitationTypeSelectPopup.vue';
import EmailRoleCategoryPopup from './vue/common_components/invitations/EmailRoleCategoryPopup.vue';
import PageAlternativeHeader from './vue/common_components/PageAlternativeHeader';
import GoToManageInvitesPageProposalPopup
    from './vue/common_components/invitations/GoToManageInvitesPageProposalPopup.vue';
// import VueTour from 'vue-tour';

// require('vue-tour/dist/vue-tour.css');

// Vue.use(VueTour);
Vue.use(Vuex);
Vue.use(uiv);
Vue.use(infiniteScroll);
Vue.use(Vue2TouchEvents, {
    disableClick: true,
    swipeTolerance: 100,
});
// Vue.component('VueMediaItemInline', MediaItemInline);
Vue.component('VueSwitch', Switch);
Vue.component('VueSwitchWithLabel', SwitchWithLabel);
Vue.component('VueSimpleHeader', SimpleHeader);
Vue.component('VueFolderButton', FolderButton);
Vue.component('InvitationTypeSelectPopup', InvitationTypeSelectPopup);
Vue.component('EmailRoleCategoryPopup', EmailRoleCategoryPopup);
Vue.component('VueStuffPreview', StuffPreview);
Vue.component('VueSearchInput', VueSearchInput);
Vue.component('AudioToggle', AudioToggle);
Vue.component('FolderItem', FolderItem);
Vue.component('SimpleLink', SimpleLink);
Vue.component('RenderQuestion', RenderQuestion);
Vue.component('SimpleLinkWithAvatar', SimpleLinkWithAvatar);
Vue.component('MediaPreview', MediaPreview);
Vue.component('MediaPreviewAddRequest', MediaPreviewAddRequest);
Vue.component('LocationWithMarker', LocationWithMarker);
Vue.component('GoToManageInvitesPageProposalPopup', GoToManageInvitesPageProposalPopup);
Vue.component('PageAlternativeHeader', PageAlternativeHeader);

import {customTermFilter, CustomTermPlugin} from './vue/filters/CustomTerm';

Vue.filter('cutName', cutNameFilter());
Vue.filter('resolveUrl', resolveUrl());
Vue.filter('backHref', add_back_url);
Vue.filter('backHrefQuery', backHrefQuery);
Vue.filter('customTerm', customTermFilter);
Vue.use(CustomTermPlugin);
Vue.use(RavenVuePlugin);

import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading, { /* options */});


import moment from 'moment';
import momentTimezone from 'moment-timezone';
import axios from "axios";
import VueLoadingSpinner from "./vue/plugins/vueLoadingSpinner";
import RenderQuestion from './angular/app/blogolog/render_question/RenderQuestion.vue';

Vue.use(VueLoadingSpinner);


moment.tz.add("Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6");

axios.defaults.xsrfCookieName = CSRF_COOKIE_NAME;
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.paramsSerializer = params => { // mock angular's default behavior
    const searchParams = new URLSearchParams();
    for (const key of Object.keys(params)) {
        const param = params[key];
        if (param === undefined) {
            continue;
        }
        if (Array.isArray(param)) {
            for (const p of param) {
                searchParams.append(key, p);
            }
        } else {
            searchParams.append(key, param);
        }
    }
    return searchParams.toString();
};
